import { Converter } from "@tblabs/storage";
import { RawShopContent } from "./RawShopContent";
import { ShopContent } from "./ShopContent";
import { RefSerializer } from "@tblabs/truffle";
import { Faq } from "./Faq";
import { RawProductCategory } from "./RawProductCategory";
import { Product } from "./Product";
import { RawTab } from "./RawTab";
import { Tab } from "./Tab";
import { ProductCategory } from "./ProductCategory";
import { RawProduct } from "./RawProduct";
import { DescriptionFieldConverter } from "./DescriptionFieldConverter";
import { RawFaq } from "./RawFaq";
import { RawField } from "./RawField";
import { RawDiscount } from "./RawDiscount";
import { Discount } from "./Discount";


export class ShopConverter extends Converter<RawShopContent, ShopContent>
{
    public ConvertToRaw(content: ShopContent): RawShopContent
    {
        return RefSerializer.Flatenize(content) as RawShopContent;
    }

    public ConvertFromRaw(raw: RawShopContent): ShopContent
    {
        const content = new ShopContent();

        content.AboutUsText.value = this.GetString(raw.AboutUsText);
        content.AboutUsFaq.Load(...this.GetArray(raw.AboutUsFaq, (x: RawFaq) => new Faq(x)));
        content.ProductCategories.Load(...this.GetArray(raw.ProductCategories, (x: RawProductCategory) => new ProductCategory(x)));
        content.Products.Load(...this.GetArray(raw.Products, (x: RawProduct) => new Product(x)));
        content.ContactTabs.Load(...this.GetArray(raw.ContactTabs, (raw: RawTab) => new Tab(raw)));
        content.Contact.Load(...this.GetArray(raw.Contact, (raw: RawField) => DescriptionFieldConverter.ToClass(raw)));
        content.RentalPageContentTabs.Load(...this.GetArray(raw.RentalPageContentTabs, (raw: RawTab) => new Tab(raw)));
        content.RentalPageContent.Load(...this.GetArray(raw.RentalPageContent, (raw: RawField) => DescriptionFieldConverter.ToClass(raw)));
        content.BasketOptions.GeneralPriceFactor.value = this.GetNumber(raw?.BasketOptions?.GeneralPriceFactor);
        content.BasketOptions.DeliveryCostForPriceAbove300.value = this.GetNumber(raw?.BasketOptions?.DeliveryCostForPriceAbove300);
        content.BasketOptions.DeliveryCostForPriceBelow300.value = this.GetNumber(raw?.BasketOptions?.DeliveryCostForPriceBelow300);
        content.BasketOptions.Discounts.Load(...this.GetArray(raw.BasketOptions?.Discounts, (raw: RawDiscount) => new Discount(raw)));
        content.Logo.value = this.GetString(raw?.Logo);

        return content;
    }
}
